import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  tileLocationRangeWrapper: {
    gap: '20px',
    display: 'flex',
  },
  shortWrapper: {
    maxWidth: '176px',
    minWidth: '176px',
  },
}));
